import React, { useEffect, useState } from "react";
import { useCurrentURL } from "../../hooks/useCurrentURL";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/reducers";
import { dispatch } from "../../App";
import { actions } from "../../redux";
import { BrainGameBase } from "../../components/BrainGame/BrainGameBase";

const BrainGamePage = () => {
    const useCurentUrl = useCurrentURL();

    const [projectId, setProjctId] = useState<string>();

    useSelector((state: RootState) => {
        if (state.project.projectId !== projectId) {
            setProjctId(state.project.projectId);
        }
    });

    useEffect(() => {

        dispatch(actions.project.setPageCommand(useCurentUrl.pageCommand));

        if (useCurentUrl.pageId !== '') {
            dispatch(actions.project.setId(useCurentUrl.pageId));
            return;
        }

        dispatch(actions.project.clearData());

    },[useCurentUrl]);

    return (<div className="container">
       <BrainGameBase></BrainGameBase>
    </div>);
}

export { BrainGamePage };
